const briefManifest = {
  featureId: "strategy_view",
  serviceKey: "brief",
  name: "Brief",
  description:
    "Analyze and structure the design challenge into a comprehensive brief",
  mode: "workflow",

  steps: [
    {
      id: "brief_analysis",
      title: "Reading Your Challenge",
      description:
        "Analyzing your design challenge and extracting key elements",
      status: "pending",
      agentKey: "DESIGN_LEAD",
      estimatedDuration: 45,
      loadingMessages: [
        'Understanding your design challenge...',
        'Extracting problem dimensions...',
        'Identifying target audience...',
        'Defining success criteria...',
        'Structuring your brief...',
      ],
    },
  ],

  outputs: [
    "goal_statement",
    "problem_statement",
    "target_statement",
    "objectives_statement",
  ],

  intro: "🚀 Analyzing your design challenge...",
  completion: "✅ **Brief Ready!** Your design brief has been structured.",
};

module.exports = briefManifest;
